import { t } from '@trimble/i18n';
import { JSX } from 'solid-js';
import { PanelLayoutWithHeaderToggle } from '@trimble/ui-components/solidjs';
import { usePaneContext } from '@mobile-mapping/providers';
import { ViewMode } from '@mobile-mapping/web3d';
import { BtnClasses, Icon, IconButton } from '@tcweb/connect-ui';
import { LayoutSelector } from '@trimble/pane-layout';
import { VIEW_MODE_ICONS } from '../view-mode-picker/view-mode-icons';

const getIcon = (viewMode: ViewMode): string => {
  return VIEW_MODE_ICONS[viewMode.type] ?? '';
};

export const LayoutTab = (props: { onClose(): void }): JSX.Element => {
  const { layouts, setLayouts } = usePaneContext();

  return (
    <PanelLayoutWithHeaderToggle
      panelTitle={t('mobileMapping.layout.title')}
      rightActions={
        <IconButton
          color={BtnClasses.TERTIARY}
          icon="tc-icon-content-close"
          size="icon-medium"
          data-cy="layout-close"
          clicked={() => props.onClose()}
        />
      }
      content={
        <LayoutSelector<ViewMode>
          layouts={layouts}
          setLayouts={setLayouts}
          iconResolver={getIcon}
          renderIcon={(iconName) => <Icon icon={iconName} size="icon-medium" />}
          testIdResolver={(viewMode) => viewMode.type}
        />
      }
    />
  );
};
